import React from 'react';
import { useParams } from 'react-router-dom';
import AppMenuBar from '../containers/Genesis/Menu/AppMenuBar';
import menuProps from 'lib/menuProps';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { isAppOnly } from '~/app/utils/pathUtils';
import PATHS from '~/app/utils/paths';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MENU_PROPS = (window as any)?.MENU_PROPS || menuProps;

export default function FXReferralLandingLayout({children}){
  const isApp = isAppOnly();
  const { locale } = useParams<{ locale: string }>();

  // Customize MenuBar props for FX pages
  const customMenuProps = {
    ...MENU_PROPS,
    logoType: 'FX SIMPLE',
    logoLink: `/${locale}${PATHS.FX_HOME}/`, // Enable logo link to FX home page
    float: true, // Make navigation sticky
    colorTheme: 'DARK', // Use dark theme for transparent menu
    zIndex: 1000 // Ensure navigation stays above the form sidebar
  };

  return isApp
    ?
    <>
      <H5Header />
      <main>
        {children}
      </main>
    </>
    : 
    <>
      <AppMenuBar
        {...customMenuProps}
        spacer={false}
      />
      <main>
        {children}
      </main>
    </>
}

const H5Header = styled(Box)(({ theme }) => ({
  height: '46px',
  position: 'fixed',
  top: '0px',
  left: '0px',
  zIndex: theme.zIndices.menubar
})); 